/* unplugin-vue-components disabled */import { render } from "./TeacherList.vue?vue&type=template&id=26ab165d&scoped=true"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"

import "./TeacherList.vue?vue&type=style&index=0&id=26ab165d&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ab165d"]])

export default __exports__